import ServiceCRUD from '../../../services/ServiceCRUDSCALE';

class ScaleService extends ServiceCRUD {
  constructor() {
    super('/api/work-scales');
  }
}

export default new ScaleService();
